import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faBan as fasBan } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import compact from "lodash/compact";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export class Khr extends AbstractStep {
	protected renderContent(): ReactNode {
		return (
			<>
				<Card.Header>
					<Card.Title className="text-center">
						Sajnos nem találtunk a megadott feltételeknek megfelelő hitelt.
					</Card.Title>
				</Card.Header>
				<Card.Body className="d-flex flex-column justify-content-center">
					<div className="text-center w-100">
						<FontAwesomeIcon icon={fasBan} size="4x" />
					</div>
					<div className="h4 mt-4 text-center w-100">
						Amennyiben lejárt, ki nem fizetett banki tartozás miatt szerepelsz a KHR listán, nem kaphatsz
						hitelt.
					</div>
				</Card.Body>
			</>
		);
	}

	protected getClassName(): string {
		return compact([super.getClassName(), "bg-danger"]).join(" ");
	}

	protected getComponentName(): string {
		return "Khr";
	}
}
